import { envSettings } from './envs'
import { mergeConfig, deviceSettings } from '@adiffengine/elements'
import { baseSettings } from './base-settings'
console.info('Merging configs', baseSettings, envSettings, deviceSettings())

export const settings = mergeConfig(baseSettings, envSettings, deviceSettings())
console.info('Settings', settings)
